var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getLastDayChanges)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getLastDayChanges.headers,"items":_vm.getLastDayChanges.values,"hide-default-footer":true}}):_c('div',{staticClass:"stats-loading"}),_c('v-btn',{attrs:{"block":""},on:{"click":_vm.fetchData}},[_vm._v("fetch data again")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }